export default __webpack_public_path__ + "static/media/jcb.4ed1849a.svg";